// Badge Block - Inline badge/tag
class BadgeBlock {
  static get toolbox() {
    return {
      title: 'Badge',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      text: data.text || 'Badge',
      color: data.color || 'blue'
    };
    this.readOnly = readOnly;
    this.wrapper = null;
    this.colors = config?.colors || ['blue', 'green', 'yellow', 'red', 'purple', 'gray'];
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _getColorClasses(color) {
    const classes = {
      blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
      green: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
      yellow: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
      red: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
      purple: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400',
      gray: 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300'
    };
    return classes[color] || classes.blue;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="inline-flex items-center gap-2" data-testid="badge-block">
        ${!this.readOnly ? `
          <select class="color-select text-xs px-2 py-1 rounded border bg-white dark:bg-slate-800">
            ${this.colors.map(c => `<option value="${c}" ${this.data.color === c ? 'selected' : ''}>${c}</option>`).join('')}
          </select>
        ` : ''}
        <span class="badge-text px-2 py-0.5 text-sm font-medium rounded ${this._getColorClasses(this.data.color)}" contenteditable="${!this.readOnly}">${this.data.text}</span>
      </div>
    `;

    if (!this.readOnly) {
      this.wrapper.querySelector('.color-select')?.addEventListener('change', (e) => {
        this.data.color = e.target.value;
        this._render();
      });
      this.wrapper.querySelector('.badge-text')?.addEventListener('input', (e) => {
        this.data.text = e.target.textContent;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default BadgeBlock;
